export const REQUEST_LOGIN = 'REQUEST_LOGIN';
export const RESOLVE_LOGIN = 'RESOLVE_LOGIN';
export const REJECT_LOGIN = 'REJECT_LOGIN';